<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div *ngIf="(logs && logs.length>0); else noLogs">
    <p-panel>
      <p-header>
        <span class="label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing' |
          translate }} {{logs ? logs.length : '0'}} logs </span>
      </p-header>
      <p-table [value]="logs" sortField="name" sortOrder="1" [paginator]="false" class="footer-over-pagination">
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="5">
              No se han encontrado logs
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="group" styleClass="col-2 text-left">Grupo <p-sortIcon field="group"></p-sortIcon>
            </th>
            <th pSortableColumn="name" styleClass="col-8 text-left">Nombre <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="date" styleClass="col-2 text-right">Fecha <p-sortIcon field="date"></p-sortIcon>
            </th>
            <th pSortableColumn="size" styleClass="col-2 text-right">Tamaño <p-sortIcon field="size"></p-sortIcon>
            </th>
            <th styleClass="text-right action-column">
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-log>
          <tr>
            <td field="group">{{log.group}}</td>
            <td field="name">{{log.name}}</td>
            <td field="date">{{log.date | date:'dd/MM/yyyy HH:mm:ss'}}</td>
            <td field="size">{{log.size | number}} Kb </td>
            <td>
              <button class="btn btn-xs btn-default" aria-expanded="false" (click)="download(log)" type="button">
                <i class="fas fa-download" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
</div>
<ng-template #noLogs>
  <div class="alert alert-danger m-b-xs text-ellipsis col-12 ng-star-inserted" role="alert"><span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{ 'Logs.noLogs' | translate }}</span>
  </div>
</ng-template>